import { render, staticRenderFns } from "./ALertTrendChart.vue?vue&type=template&id=4b186434"
import script from "./ALertTrendChart.vue?vue&type=script&lang=js"
export * from "./ALertTrendChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports